/**
 * Elapsed-time formatting for live tool-call timers.
 *
 * The timer wakes up roughly once per second while a tool is running
 * and shows the user how long the SDK has been waiting on the result.
 * Format trades precision for at-a-glance readability:
 *
 *   - < 60s             "12s"
 *   - < 60min           "1m 04s"
 *   - >= 60min          "1h 02m 30s"
 *
 * Negative or non-finite inputs render as ``"0s"`` so a misbehaving
 * caller can never blow up the UI.
 */

export function formatElapsed(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) return '0s';
  const totalSeconds = Math.floor(ms / 1000);
  const seconds = totalSeconds % 60;
  const totalMinutes = Math.floor(totalSeconds / 60);
  const minutes = totalMinutes % 60;
  const hours = Math.floor(totalMinutes / 60);
  if (hours > 0) {
    return `${hours}h ${pad2(minutes)}m ${pad2(seconds)}s`;
  }
  if (minutes > 0) {
    return `${minutes}m ${pad2(seconds)}s`;
  }
  return `${seconds}s`;
}

function pad2(value: number): string {
  return value < 10 ? `0${value}` : `${value}`;
}
